class PQPCollectionPage {
  /** @param {HTMLElement} root */
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-pqp-collection-filter-form]');
    this.sort = root.querySelector('[data-pqp-collection-sort]');
    this.onDocumentClick = this.onDocumentClick.bind(this);

    if (this.form && this.sort) {
      this.sort.addEventListener('change', () => this.form.requestSubmit());
    }

    document.addEventListener('click', this.onDocumentClick);
  }

  /** @param {MouseEvent} event */
  onDocumentClick(event) {
    if (!(event.target instanceof Node)) return;

    this.root.querySelectorAll('.pqp-collection-page__filter[open]').forEach((filter) => {
      if (!filter.contains(event.target)) filter.removeAttribute('open');
    });
  }
}

document.querySelectorAll('[data-pqp-collection-page]').forEach((root) => new PQPCollectionPage(root));
